



























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class AssumptionInputField extends Vue {
  labelAdjustments = 'margin-top: 10px; margin-right: 18px;';
  inputValue: number | null = null;

  @Prop()
  value!: number;

  @Prop({
    type: String,
    default: '-',
  })
  displayValue!: string;

  @Prop({ default: false })
  isDisabled!: boolean;

  @Prop({ default: false })
  horizontalLabel!: boolean;

  @Prop({ default: '' })
  inputLabel!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  private setFontColor!: boolean;

  valueDetected(value: number | string) {
    this.$emit('input', value);
  }

  get inputCustomStyle() {
    if (this.setFontColor === true) {
      return `  color: #FF4C4B;,`;
    }
    return '';
  }
}
